import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) return '';

    // Convert Unix timestamp to milliseconds
    const timestamp = value * 1000;
    const seconds = Math.floor((Date.now() - timestamp) / 1000);

    const intervals = {
      año: 31536000,
      mes: 2592000,
      semana: 604800,
      día: 86400,
      hora: 3600,
      minuto: 60,
      segundo: 1
    };

    for (const [unit, secondsInUnit] of Object.entries(intervals)) {
      const counter = Math.floor(seconds / secondsInUnit);
      
      if (counter > 0) {
        if (counter === 1) {
          return `hace 1 ${unit}`;
        } else if (unit === 'mes') {
          return `hace ${counter} meses`;
        } else {
          return `hace ${counter} ${unit}s`;
        }
      }
    }

    return 'hace un momento';
  }
}